/**
 * Display labels for the org dashboard modules. Used as the source of truth for the
 * sidebar rows, page headers, and route module names (which drive the browser tab title) so
 * the same section name does not have to be kept in sync by hand across those locations.
 */
export const ORG_DASHBOARD_MODULES = {
  allEntities: "All Entities",
  manageTeam: "Manage Team",
  manageEntities: "Manage Entities",
  settings: "Organization Settings",
  profile: "Profile",
  subscription: "Subscription",
} as const
